import { push } from 'react-router-redux';

import api from '../../api/index.js';
import ui from '../ui/actions.js';
import users from './actions.js';
import { searchByParams, searchByID } from '../app/operations.js';

import { toStore, toAPI } from './transform.js';
import { toSubmissionError } from '~/utils/transform.js';

import { isUUID } from '~/utils/index.js';
import mapping from '~/utils/mapping.json';


/*
 * redux-form onSubmit function, called by handleSubmit
 */
export async function search(values, dispatch) {

    const { terms, archived, deleted } = values.toJS();

    if (isUUID(terms)) {
        searchByID('users', terms, dispatch);

    } else {
        // extend the keyword matching to also filter based on the email addresses
        // when terms contains a @ symbol
        const params = {
            types: mapping.vertex_types.by_name.USER,
            email_terms: true,
            limit: -1,
            terms,
            archived,
            deleted,
        };

        searchByParams(params, dispatch);
    }
}


export const fetchUser = id => async (dispatch, getState) => {

    try {
        const res = await dispatch(api.get(`/users/${id}`));

        // NOTE: depends on having system feature flags in store check fetchUserData
        dispatch(users.data.set(toStore(res.data, getState)));

    } catch (error) {
        // 404 Not Found
        if (error.response && error.response.status === 404) {
            dispatch(ui.flash.error({ header: 'User not found' }));
        }
        throw error;
    }
};


/*
 * redux-form onSubmit function, called by handleSubmit
 */

// Action creator to fetch email logs
export const fetchEmailLogs = userId => async (dispatch) => {
    dispatch(users.emailLogs.fetchRequest());
    try {
        // userId = '49aa61d2-fd61-4aeb-5557-c521e1ff127a';
        const res = await dispatch(api.get(`/users/${userId}/emaillogs`));
        const text = res.data;
        return res.data;

    } catch (error) {
        console.error('Error fetching email logs:', error);
        dispatch(users.email_logs.fetchFailure(error.message));
    }
};

// Action creator to fetch user SSO Data
export const fetchUserSsoData = userId => async (dispatch) => {
    dispatch(users.ssoData.fetchRequest());
    try {
        const res = await dispatch(api.get(`/users/${userId}/authorizations`));
        const data = res.data;
        dispatch(users.ssoData.fetchSuccess(data));
        return data;
    } catch (error) {
        console.error('Error fetching User SSO Data:', error);
        dispatch(users.ssoData.fetchFailure(error.message));
    }
};


/*
 * redux-form onSubmit function, called by handleSubmit
 */
export async function patchUser(values, dispatch, props) {
    const { match: { params: { id } } } = props;

    try {
        await dispatch(api.patch(`/users/${id}`, {
            data: toAPI(values.toJS()),
        }));

        dispatch(push(`/users/${id}`));
        dispatch(ui.flash.success({ header: 'User updated successfully' }));

    } catch (error) {
        throw toSubmissionError(error);
    }
}

